import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="loginShell">
      <div className="loginCard card-elevated">
        <h1 className="heading-2">404</h1>
        <p className="text-element-mid">No encontramos lo que buscás.</p>
        <Link to="/" className="btn btn-primary" style={{ marginTop: '1rem' }}>
          <span className="btn-font-style">Volver al inicio</span>
        </Link>
      </div>
    </div>
  );
}
